// extracted by mini-css-extract-plugin
module.exports = {"menu":"NavMenu_menu__QeniN","statusIcon":"NavMenu_statusIcon__1uIwy"};